export default {"src":"/_next/static/media/arrow-down.744f7f8a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};